// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__CBZBq","signInForm":"styles_signInForm__Bwc25","checkboxContainer":"styles_checkboxContainer__tO4PJ","error":"styles_error__4C3vZ"};